// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/modules/es6.math.fround.js
// module id = 352
// module chunks = 128